import { Box } from "@mui/material";
import { useSelectedProject } from "Hooks";
import { looksLikeJSON } from "./jsonParsingUtils";
import StyledMarkdown from "../StyledMarkdown";

interface UseResponseFallbackOptions {
  response: string;
  parsedData: any;
}

export const useResponseFallback = ({ response, parsedData }: UseResponseFallbackOptions) => {
  const { selectedClient, selectedProject } = useSelectedProject();

  if (!response) {
    return { render: <></> };
  }

  // If it's not JSON or we couldn't parse any fields, render as markdown (for old messages)
  if (!parsedData) {
    // Check if it looks like JSON but is still incomplete/processing
    if (looksLikeJSON(response)) {
      return { render: <Box sx={{ p: 2 }}>Processing...</Box> };
    }

    // Otherwise, it's plain text (old message format), render as markdown
    const processedResponse = (response || "").replaceAll(
      `clients/:clientId/projects/:projectId`,
      `clients/${selectedClient!.id}/projects/${selectedProject!.id}`
    );
    return { render: <StyledMarkdown>{processedResponse}</StyledMarkdown> };
  }

  return { render: null, hasData: true };
};

